function n(o) {
  var t;
  return o == null || (t = o.getRootNode) === null || t === void 0 ? void 0 : t.call(o);
}
function u(o) {
  return n(o) instanceof ShadowRoot;
}
function d(o) {
  return u(o) ? n(o) : null;
}
export {
  d as g
};
//# sourceMappingURL=shadow-9lsz-71t.mjs.map
